// extracted by mini-css-extract-plugin
module.exports = {"content_list":"content_list-3eal2h3Q","chip_item":"chip_item-1NcNzI_h"};